import FaqAccordion from "@/components/common/FaqAccordion";
import { useTranslation } from "react-i18next";

const FaqSection = () => {
  const { t } = useTranslation();

  return (
    <section className="py-12 bg-white rounded-2xl">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-6 md:mb-12">
          <h2 className="text-3xl md:text-4xl font-semibold text-slate-900 mb-4 md:mb-6">
            {t('faq.title')}
          </h2>
        </div>

        <FaqAccordion />
      </div>
    </section>
  );
};

export default FaqSection;
